// Small utilities for debugging JWT-related issues in the browser.
// These do NOT verify signatures (frontend cannot), they only decode header/payload.

const base64UrlToBase64 = (input) => {
  const padded = input.replace(/-/g, '+').replace(/_/g, '/');
  const padLen = (4 - (padded.length % 4)) % 4;
  return padded + '='.repeat(padLen);
};

const safeJsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const safeTokenPreview = (token) => {
  if (!token || typeof token !== 'string') return null;
  const start = token.slice(0, 10);
  const end = token.slice(-6);
  return `${start}...${end} (len=${token.length})`;
};

export const decodeJwtParts = (token) => {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return { partsCount: parts.length };

  try {
    const headerJson = atob(base64UrlToBase64(parts[0]));
    const payloadJson = atob(base64UrlToBase64(parts[1]));
    return {
      partsCount: parts.length,
      header: safeJsonParse(headerJson),
      payload: safeJsonParse(payloadJson),
    };
  } catch {
    return { partsCount: parts.length, decodeError: true };
  }
};

export const getHostnameFromUrl = (url) => {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
};

export const getProjectRefFromHostname = (hostname) => {
  // Typical Supabase: <project-ref>.supabase.co
  if (!hostname) return null;
  const match = hostname.match(/^([^.]+)\.supabase\.co$/i);
  return match?.[1] || null;
};

